<ds-price-summary
  [total]="totalLabel"
  [subtitle]="resolvedSubtitle"
  [groups]="groups"
  [actions]="actions"
/>
